import React, { useEffect, useState } from "react";
import { getSolicitudesEmision } from "./actions";
import { useSelector, useDispatch } from "react-redux";
import ListadoSolicitudesPendientesSucursal from "./ListadoSolicitudesPendientesSucursal";
import { solicitudesPendientesSucursalPath } from "~constants/referenceNames";
import {
  getUrlWithParameters,
  updateUrlParameters,
  UrlParam,
} from "~hooks/urlSearcherManager";
import { useHistory, useLocation } from "react-router-dom";
import {
  setTake,
  setPage,
  selectSearchCriteria,
  selectFechaDesde,
  selectFechaHasta,
  selectEstado,
} from "./Filtros/actions";
import SectionLayout from "~styled/layouts/sectionLayout/SectionLayout";
import { FechaFiltro, FiltroValue, TakeValue } from "../types";

interface SliceSolicitudesPendientesSucursal {
  take: TakeValue;
  page: number;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
  searchCriteria: string;
  estado: FiltroValue[];
}

const useReduxSelector = () =>
  useSelector<any, SliceSolicitudesPendientesSucursal>((state) => ({
    take: state.solicitudesPendientesSucursalFiltrosReducer.take,
    page: state.solicitudesPendientesSucursalFiltrosReducer.page,
    fechaDesde: state.solicitudesPendientesSucursalFiltrosReducer.fechaDesde,
    fechaHasta: state.solicitudesPendientesSucursalFiltrosReducer.fechaHasta,
    searchCriteria:
      state.solicitudesPendientesSucursalFiltrosReducer.searchCriteria,
    estado: state.solicitudesPendientesSucursalFiltrosReducer.estado,
  }));

const params: UrlParam[] = [
  {
    name: "searchCriteria",
    nameUrl: "SearchCriteria",
    action: selectSearchCriteria,
  },
  {
    name: "fechaDesde",
    nameUrl: "Desde",
    action: selectFechaDesde,
    isDate: true,
  },
  {
    name: "fechaHasta",
    nameUrl: "Hasta",
    action: selectFechaHasta,
    isDate: true,
  },
  {
    name: "estado",
    nameUrl: "Estado",
    action: selectEstado,
  },
  { name: "take", nameUrl: "Take", action: setTake },
];

const SolicitudesPendientesSucursalContainer: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const currentState = useReduxSelector();

  const { take, page, fechaDesde, fechaHasta, searchCriteria, estado } =
    currentState;

  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const url = getUrlWithParameters({
      params,
      currentState,
      index: solicitudesPendientesSucursalPath,
    });

    setUrl(url);
    history.replace(url);

    //eslint-disable-next-line
  }, [dispatch, take, page, fechaDesde, fechaHasta, searchCriteria, estado]);

  useEffect(() => {
    updateUrlParameters({
      params,
      location,
      dispatch,
      setPage,
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (url) {
      dispatch(
        getSolicitudesEmision(
          page * Number(take),
          take,
          searchCriteria,
          fechaDesde,
          fechaHasta,
          estado
        ) as any
      );
    }
    //eslint-disable-next-line
  }, [dispatch, url]);

  return (
    <SectionLayout title={"Solicitudes Pendientes"}>
      <ListadoSolicitudesPendientesSucursal />
    </SectionLayout>
  );
};

export default SolicitudesPendientesSucursalContainer;
